import { IEventRequestParams } from './shared.dto';

export abstract class IEventLinksDAO {
    public abstract getEventLinkTypes(params: IEventRequestParams): Promise<IEventLinkType[]>;
    public abstract deleteEventLink(linkId: number, params: IEventRequestParams): Promise<void>;
    public abstract editEventLink(linkId: number, payload: Omit<IEventLinkDTO, 'linkId'>, params: IEventRequestParams): Promise<void>;
    public abstract getEventLinks(params: IEventRequestParams): Promise<IEventLinkDTO[]>;
    public abstract createEventLink(payload: Omit<IEventLinkDTO, 'linkId'>, params: IEventRequestParams): Promise<void>;
}

export interface IEventLinkType {
    value: string;
    default: boolean;
}

export interface IEventLinkDTO {
    linkId: number;
    type: string;
    label: string;
    url: string;
}
